import { useAtomValue } from 'jotai';
import { openFloatingChat } from '@fiverr-private/go_floating_chat_triggers';
import { floatingChatDataAtom } from '@fiverr-private/seller_pages_toolbox';
import { AgencySeller } from '../../types';
import { useIsSellerOnline } from '../useIsSellerOnline';
import { useAgencySellerData } from '../useAgencySellerData';

export const useFloatingChatTrigger = () => {
    const { isFloatingChatEnabled, showConversationSavedTooltip } = useAtomValue(floatingChatDataAtom);
    const { username, profileImageUrl, displayName, sellerId } = useAgencySellerData(selectSellerSlice);
    const isOnline = useIsSellerOnline();

    return {
        isFloatingChatEnabled,
        openFloatingChat: () =>
            openFloatingChat({
                data: {
                    recipientUsername: username,
                    showConversationSavedTooltip,
                    seller: {
                        username,
                        name: displayName || undefined,
                        imageSrc: profileImageUrl || undefined,
                        isOnline,
                    },
                    initialData: {
                        sellerId,
                        entryPoint: 'seller',
                    },
                },
            }),
    };
};

function selectSellerSlice(seller: AgencySeller) {
    return {
        displayName: seller.user.profile.displayName,
        username: seller.user.name,
        profileImageUrl: seller.user.profileImageUrl,
        sellerId: seller.user.id,
    };
}
